<template>
  <div class="errPage-container">
    <el-row>
      <el-col :span="12">
        <img width="360" height="360" :src="errImage" alt="You do not allow to this page!" />
      </el-col>
      <el-col :span="12">
        <h2 class="text-jumbo text-ginormous">OOPS!</h2>
        <p class="copyright">版权所有 XPS</p>
        <h3 class="msg">网管说你没有权限去该页面……</h3>
        <ul class="list-unstyled">
          <li>你可以去:</li>
          <li class="link-type">
            <a href="javascript:;" @click="back">返回</a>
          </li>
          <li class="link-type">
            <a href="https://www.bilibili.com/">去逛小破站</a>
          </li>
          <li>
            <a href="https://medusa.xsyxsc.com/">去美杜莎发版</a>
          </li>
        </ul>
        <router-link to="/" class="return-home">返回首页</router-link>
      </el-col>
    </el-row>

  </div>
</template>

<script>

export default {
  name: "Page401",
  data () {
    return {
      errImage: `https://front-xps-cdn.xsyx.xyz/2021/10/23/991391518.png`
    };
  },
  methods: {
    back () {
      if (this.$route.query.noGoBack) {
        this.$router.push({ path: "/" });
      } else {
        this.$router.go(-1);
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.errPage-container {
  width: 800px;
  max-width: 100%;
  margin: 100px auto;
  .msg {
    margin-bottom: 10px;
    -webkit-animation-name: slideUp;
    animation-name: slideUp;
    -webkit-animation-duration: 0.5s;
    animation-duration: 0.5s;
    -webkit-animation-delay: 0.1s;
    animation-delay: 0.1s;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
  }
  .return-home {
    display: block;
    float: left;
    width: 110px;
    height: 36px;
    background: #1482f0;
    border-radius: 100px;
    text-align: center;
    color: #ffffff;
    font-size: 14px;
    line-height: 36px;
    cursor: pointer;
    -webkit-animation-name: slideUp;
    animation-name: slideUp;
    -webkit-animation-duration: 0.5s;
    animation-duration: 0.5s;
    -webkit-animation-delay: 0.3s;
    animation-delay: 0.3s;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
  }
  .copyright {
    font-size: 13px;
    line-height: 21px;
    color: grey;
    opacity: 0;
    margin-bottom: 30px;
    -webkit-animation-name: slideUp;
    animation-name: slideUp;
    -webkit-animation-duration: 0.5s;
    animation-duration: 0.5s;
    -webkit-animation-delay: 0.2s;
    animation-delay: 0.2s;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
  }
  .pan-gif {
    margin: 0 auto;
    display: block;
  }
  .pan-img {
    display: block;
    margin: 0 auto;
    width: 100%;
  }
  .text-jumbo {
    font-size: 32px;
    line-height: 40px;
    color: #1482f0;
    font-weight: 700;
    -webkit-animation-name: slideUp;
    animation-name: slideUp;
    -webkit-animation-duration: 0.5s;
    animation-duration: 0.5s;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
  }
  .list-unstyled {
    -webkit-animation-name: slideUp;
    animation-name: slideUp;
    -webkit-animation-duration: 0.5s;
    animation-duration: 0.5s;
    -webkit-animation-delay: 0.2s;
    animation-delay: 0.2s;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
    font-size: 14px;
    li {
      padding-bottom: 5px;
    }
    a {
      color: #008489;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  @keyframes slideUp {
    0% {
      transform: translateY(60px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
}
</style>
